import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {BatchAudit, BatchAuditSearchParams, BatchOpResult} from '@accounting/_common/models/batch-audit.models';

export const CheckState = createAction(
    '[BatchAudits] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: BatchAudit[] } }>()
);

export const CheckStateSuccess = createAction(
    '[BatchAudits] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: BatchAudit[] } }>()
);

export const LoadList = createAction(
    '[BatchAudits] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[BatchAudits] Load List Success',
    props<{ payload: { items: BatchAudit[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[BatchAudits] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[BatchAudits] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[BatchAudits] Set Filter',
    props<{ payload: BatchAuditSearchParams }>()
);

export const SetLoading = createAction(
    '[BatchAudits] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[BatchAudits] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const SetCurrentBatchOperation = createAction(
    '[BatchAudits] Set Current Batch Operation',
    props<{ payload: { batchOperation?: BatchOpResult, dialogOpened?: boolean } }>()
);

export const ListChanged = createAction(
    '[BatchAudits] List Changed'
);

export const SetInitialState = createAction(
    '[BatchAudits] Set Initial State'
);
